import { queryOptions, useQuery } from '@tanstack/react-query';
import {
  getConversationsOverview,
  getDashboardStats,
  getInteractionsUsage,
  getSentimentAnalysis,
} from './dashboard.service';
import { DashboardFilters } from './dashboard.types';

export const dashboardQueryKeys = {
  all: ['dashboard'] as const,
  stats: (filters: DashboardFilters) => [
    ...dashboardQueryKeys.all,
    'stats',
    filters,
  ] as const,
  conversationsOverview: (filters: DashboardFilters) => [
    ...dashboardQueryKeys.all,
    'conversations-overview',
    filters,
  ] as const,
  sentiment: (filters: DashboardFilters) => [
    ...dashboardQueryKeys.all,
    'sentiment',
    filters,
  ] as const,
  interactions: (filters: DashboardFilters) => [
    ...dashboardQueryKeys.all,
    'interactions',
    filters,
  ] as const,
};

export const useDashboardStats = (filters: DashboardFilters, enabled = true) => {
  return useQuery({
    ...queryOptions({
      queryKey: dashboardQueryKeys.stats(filters),
      queryFn: () => getDashboardStats(filters),
      staleTime: 30_000,
      gcTime: 30_000,
      refetchOnWindowFocus: false,
    }),
    enabled,
  });
};

export const useConversationsOverview = (
  filters: DashboardFilters,
  enabled = true,
) => {
  return useQuery({
    ...queryOptions({
      queryKey: dashboardQueryKeys.conversationsOverview(filters),
      queryFn: () => getConversationsOverview(filters),
      staleTime: 30_000,
      gcTime: 30_000,
      refetchOnWindowFocus: false,
    }),
    enabled,
  });
};

export const useSentimentAnalysis = (
  filters: DashboardFilters,
  enabled = true,
) => {
  return useQuery({
    ...queryOptions({
      queryKey: dashboardQueryKeys.sentiment(filters),
      queryFn: () => getSentimentAnalysis(filters),
      staleTime: 30_000,
      gcTime: 30_000,
      refetchOnWindowFocus: false,
    }),
    enabled,
  });
};

export const useInteractionsUsage = (
  filters: DashboardFilters,
  enabled = true,
) => {
  return useQuery({
    ...queryOptions({
      queryKey: dashboardQueryKeys.interactions(filters),
      queryFn: () => getInteractionsUsage(filters),
      staleTime: 30_000,
      gcTime: 30_000,
      refetchOnWindowFocus: false,
    }),
    enabled,
  });
};
